import React from 'react';
import { useField, connect } from 'formik';

import {
  Avatar, Box, SvgIcon, useTheme
} from '@material-ui/core/index';
import OrderableList from '../OrderableList';
import IconPicker from '../IconPicker';
import useModal from '../Modal/useModal';
import IconRenderer from '../IconRenderer';
import Button from '../Button';


const FormikIconPicker = (props: any) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  const { isOpen, closeModal, openModal } = useModal();
  const theme = useTheme();

  return (
    <>
      <Box display="flex" alignItems="center" flexGrow="1">
        <Box mr={1}>
          <Avatar style={{ backgroundColor: theme.palette.secondary.main }}>
            <SvgIcon fontSize="small">
              <IconRenderer iconName={field.value} />
            </SvgIcon>
          </Avatar>
        </Box>
        <Button fullWidth onClick={openModal}>Select icon</Button>
      </Box>
      {
        isOpen && (
          <IconPicker
            isOpen={isOpen}
            handleSelectIcon={(value: string) => props.formik.setFieldValue(props.name, value)}
            onClose={closeModal}
          />
        )
      }
    </>
  );
};

export default connect(FormikIconPicker);
